import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { GenericNotification } from './GenericNotification';

export const cantDownloadFileNotification = () => {
  const CantDownloadFileNotification = ({ notification }) => (
    <GenericNotification
      notification={notification}
      text={<FormattedMessage id="files-manager.cant-download-file-notification" />}
      type={NotificationType.Destructive}
    />
  );

  return CantDownloadFileNotification;
};
